export const MainComposite = { Asphalt:0, Concrete:1, Grass:2, Sand:3};

export default class Runway {

    static getMainCompositeText(mainComposite) {
        switch (mainComposite){
            case  MainComposite.Asphalt:
                return 'Asphalt';
            case  MainComposite.Concrete:
                return 'Concrete';
            case  MainComposite.Grass:
                return 'Grass';
            case  MainComposite.Sand:
                return 'Sand';
            default:
                console.error(mainComposite + ' main composite unknown')
                return 'Unknown';
        }
    }
}